import { useTheme } from "@mui/material";
import clsx from "clsx";
import { Calendar1 } from "iconsax-react";
import moment from "moment";
import React from "react";

import Calendar from "@SonarCX/components/atoms/Calendar";
import { formatDateRelative } from "@SonarCX/utilities";

const DueDateSection = ({ classes, handleChange, values, canEdit }) => {
  const calenderRef = React.useRef();
  const theme = useTheme();

  const dueDate = React.useMemo(
    () => moment(values.due_date).startOf("D").toDate(),
    [values.due_date],
  );

  return (
    <div
      className={clsx(
        classes.center,
        classes.label,
        classes.mobile,
        classes.container,
      )}
    >
      <span className={clsx(classes.center, classes.label)}>
        <Calendar1
          size={theme.size.base}
          variant="Bulk"
          color={theme.palette.primary.main}
        />
        DUE
      </span>

      <div className={classes.center} ref={calenderRef}>
        <Calendar
          value={dueDate}
          onChange={handleChange("due_date")}
          anchorEl={calenderRef}
          disabled={!canEdit}
        >
          {formatDateRelative(dueDate, true)}
        </Calendar>
      </div>
    </div>
  );
};

export default DueDateSection;
